import React from "react";

const Resource = () => {
  return (
    <div className="card rounded-0 border-0 overflow-auto h-100 w-100 d-flex align-items-center justify-content-center">
      <iframe
        src={"https://Hubinfusedanalytics.com"}
        title="resource Dashboard"
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default Resource;
